module.exports = __webpack_public_path__ + "img/facebook.e13e8de4.svg";